export default __webpack_public_path__ + "static/media/icon-network.364db25a.svg";